import { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import Logo from '../assets/Images/fully-final-logo.png'
import Departments from './../Departments'
import { Drawer, IconButton, Box } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import CloseIcon from '@mui/icons-material/Close'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Marquee from "react-fast-marquee";
import BookAppointmentDialog from './BookAnAppointmentDialogue'
export default function Header() {
  const location = useLocation()
  const [isScrolled, setIsScrolled] = useState(false)
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const [isMobileDropdownOpen, setIsMobileDropdownOpen] = useState(false)
  const [dialogOpen, setDialogOpen] = useState(false);
  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    const handleClickOutside = event => {
      if (!event.target.closest('.dropdown-container')) {
        setIsDropdownOpen(false)
      }
    }
    document.addEventListener('click', handleClickOutside)
    return () => document.removeEventListener('click', handleClickOutside)
  }, [])

  return (
    <div
      className={`z-50 mb-8 transition-all duration-300 ${isScrolled ? 'fixed top-0 w-full bg-white shadow-md' : 'relative'
        }`}
    >
      <nav className='border-gray-200 relative'>
        <div className='max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4'>
          <Link to='/' className='flex items-center space-x-3'>
            <img loading='eager' src={Logo} alt='Magnaid' className='' />
          </Link>
          {/* Mobile Menu Button - Visible only on mobile */}
          <div className='lg:hidden'>
            <IconButton aria-label="Close menu" onClick={() => setIsDrawerOpen(true)}>
              <MenuIcon fontSize='large' />
            </IconButton>
          </div>
          {/* Navbar Links */}
          <div className='w-full hidden lg:block lg:w-auto'>
            <ul className='font-light capitalize flex flex-col items-center p-4 md:p-0 mt-4 text-[18px] text-[#077979] lg:flex-row lg:space-x-8 md:mt-4 md:border-0 font-body'>
              <li>
                <Link aria-label="Go To Home Page"
                  to='/'
                  className={
                    location.pathname === '/'
                      ? 'text-orange font-bold'
                      : 'hover:text-orange'
                  }
                >
                  Home
                </Link>
              </li>
              <li>
                <Link aria-label="Go To Home Page"
                  to='/about-us'
                  className={
                    location.pathname === '/about-us'
                      ? 'text-orange font-bold'
                      : 'hover:text-orange'
                  }
                >
                  About Us
                </Link>
              </li>

              {/* Dropdown with Two-Column Layout */}
              <li className='relative dropdown-container'>
                <button aria-label="Go To Home Page"
                  onMouseEnter={() => setIsDropdownOpen(true)}
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  className={`flex items-center gap-1 hover:text-orange`}
                >
                  Department
                  <svg
                    className='w-4 h-4'
                    viewBox='0 0 20 20'
                    fill='currentColor'
                  >
                    <path
                      fillRule='evenodd'
                      d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z'
                      clipRule='evenodd'
                    />
                  </svg>
                </button>

                {/* Dropdown Content */}
                <div
                  className={`absolute lg:left-[140px] xl:left-1/2 transform -translate-x-1/2 top-full mt-8 w-[1000px] bg-white shadow-lg border border-[#c4d6d6] rounded-[16px] p-8 z-50 transition-all duration-300 ${isDropdownOpen ? 'block' : 'hidden'
                    }`}
                  onMouseEnter={() => setIsDropdownOpen(true)}
                  onMouseLeave={() => setIsDropdownOpen(false)}
                >
                  <div className='grid grid-cols-2 gap-8'>
                    {/* Medical Department */}
                    <div>
                      <p className='text-[20px]  text-thickGreen font-heading mb-6 text-center'>
                        Medical Department
                      </p>
                      <div className='grid grid-cols-2 gap-4'>
                        {Departments.medical.map((service, index) => (
                          <Link
                            key={index} aria-label={service.title}
                            to={`/${service.metaUrl}`}
                            // to={`service/${service.title
                            //   .toLowerCase()
                            //   .replace(/\s+/g, '-')}`}
                            className='hover:text-orange transition-colors whitespace-nowrap'
                            onClick={() => setIsDropdownOpen(false)}
                          >
                            {service.title}
                          </Link>
                        ))}
                      </div>
                    </div>

                    {/* Surgical Department */}
                    <div>
                      <p className='text-[20px]  text-thickGreen font-heading mb-6 text-center'>
                        Surgical Department
                      </p>
                      <div className='grid grid-cols-2 gap-4'>
                        {Departments.surgical.map((service, index) => (
                          <Link aria-label={service.title}
                            key={index}
                            to={`/${service.metaUrl}`}
                            className='hover:text-orange transition-colors whitespace-nowrap'
                            onClick={() => setIsDropdownOpen(false)}
                          >
                            {service.title}
                          </Link>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              <li>
                <Link
                  to='/laboratory-services-in-hospital'
                  className={
                    location.pathname === '/laboratory-services-in-hospital'
                      ? 'text-orange font-bold'
                      : 'hover:text-orange'
                  }
                >
                  Lab & Diagnostic
                </Link>
              </li>
              <li>
                <Link
                  to='/contact-us'
                  className={
                    location.pathname === '/contact-us'
                      ? 'text-orange font-bold'
                      : 'hover:text-orange'
                  }
                >
                  Contact Us
                </Link>
              </li>

              {/* Book Appointment Button */}
              <li>
                <button aria-label="book" onClick={handleOpenDialog} className='bg-orange hover:bg-lightGreen p-4 px-5 rounded-full text-white font-medium  transition-transform duration-300 hover:translate-y-[-3px]'>
                  Book an Appointment
                </button>
              </li>
            </ul>
          </div>
          {/* Mobile Sidebar */}
          <Drawer
            anchor='right'
            open={isDrawerOpen}
            onClose={() => setIsDrawerOpen(false)}
          >
            <Box className='md:w-[400px] w-[300px] h-full bg-white flex flex-col p-6'>
              {/* Close Button */}
              <div className='flex justify-between items-center mb-8'>
                <img src={Logo} alt='Magnaid' className='w-[120px]' />
                <IconButton aria-label="Close menu" onClick={() => setIsDrawerOpen(false)}>
                  <CloseIcon fontSize='large' />
                </IconButton>
              </div>

              {/* Sidebar Links */}
              <ul className='space-y-4 text-[18px] text-[#077979] font-light capitalize'>
                <li>
                  <Link
                    to='/' aria-label="Go To Home Page"
                    className='hover:text-orange'
                    onClick={() => setIsDrawerOpen(false)}
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <Link aria-label="Go To About Page"
                    to='/about-us'
                    className='hover:text-orange'
                    onClick={() => setIsDrawerOpen(false)}
                  >
                    About Us
                  </Link>
                </li>

                {/* Mobile Dropdown */}
                <li>
                  <button aria-label="open"
                    onClick={() =>
                      setIsMobileDropdownOpen(!isMobileDropdownOpen)
                    }
                    className='flex justify-between items-center w-full hover:text-orange'
                  >
                    Department <ExpandMoreIcon />
                  </button>
                  {isMobileDropdownOpen && (
                    <div className='ml-4 mt-2 h-[200px] overflow-y-auto '>
                      <h3 className=' text-xl font-body  text-thickGreen mb-4'>
                        Medical Department
                      </h3>
                      {Departments.medical.map((service, index) => (
                        <Link aria-label={service.title}
                          key={index}
                          to={`/${service.metaUrl}`}
                          className='block text-lightGreen hover:text-orange'
                          onClick={() => setIsDrawerOpen(false)}
                        >
                          {service.title}
                        </Link>
                      ))}
                      <h3 className=' text-xl  font-body text-thickGreen my-4'>
                        Surgical Department
                      </h3>
                      {Departments.surgical.map((service, index) => (
                        <Link
                          key={index} aria-label={service.title}
                          to={`/${service.metaUrl}`}
                          className='block text-lightGreen hover:text-orange'
                          onClick={() => setIsDrawerOpen(false)}
                        >
                          {service.title}
                        </Link>
                      ))}
                    </div>
                  )}
                </li>

                <li>
                  <Link aria-label="pricing"
                    to='/laboratory-services-in-hospital'
                    className='hover:text-orange'
                    onClick={() => setIsDrawerOpen(false)}
                  >
                    Pricing
                  </Link>
                </li>
                <li>
                  <Link aria-label=" contact us"
                    to='/contact-us'
                    className='hover:text-orange'
                    onClick={() => setIsDrawerOpen(false)}
                  >
                    Contact Us
                  </Link>
                </li>
              </ul>
            </Box>
          </Drawer>
        </div>
      </nav>
      {/* <button className='w-full ' onClick={handleOpenDialog}> */}
        <Marquee
          speed={50}
          gradient={false} onClick={handleOpenDialog}
          className="bg-lightGreen text-lg text-white  py-2 font-body font-bold"
        >
          Explore our latest updates and important announcements here.&nbsp;&nbsp;&nbsp;&nbsp;
        </Marquee>
      {/* </button> */}
      {/* <Marquee
          speed={100}
          gradient={false} onClick={handleOpenDialog}
          className="bg-lightGreen text-lg text-white  py-2 font-body font-bold"
        >
          Special Liver Health Package only on March 30th from 10am t0 5pm. Starting at 999/- with a FREE Consultation!  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </Marquee> */}

      <BookAppointmentDialog open={dialogOpen} onClose={handleCloseDialog} />
    </div>
  )
}